import React from 'react'

import LocaleSwitcher from './LocaleSwitcher'

const Logo = ({ config }) => {
  const path = `/themes/${config.theme}/${config.logo || 'logo.png'}`

  return (
    <header className='logo'>
      <a href={config.homeURL}><img src={path} className='logo' alt='logo' /></a>
      <LocaleSwitcher />
    </header>
  )
}

export default Logo
